export enum AutomotiveRole {
  TECHNICIAN = '1',
  SERVICE_ADVISOR = '2',
  SERVICE_MANAGER = '3',
  SALESPERSON = '4',
  SALES_MANAGER = '5',
  BDC = '6',
}

export const automotiveRoleOptions = [
  { value: '4', label: 'Salesperson' },
  { value: '5', label: 'Sales Manager' },
  { value: '3', label: 'Service Manager' },
  { value: '2', label: 'Service Advisor' },
  { value: '1', label: 'Technician' },
  { value: '6', label: 'BDC' },
];
